export default __webpack_public_path__ + "static/media/ISMO CLASS-9 EXAM PATTERN 2025.22c16e55.pdf";